module.exports = __webpack_public_path__ + "static/media/twN2.e209b7b4.png";